import { Grid, SxProps, Theme } from "@mui/material";
import { useEffect } from "react";
import { Footer } from "../../containers/Footer/Footer";
import { TopPageHeader } from "./containers/TopPageHeader/TopPageHeader";
import { About } from "./containers/About/About";
import { Company } from "./containers/Company/Company";
import { Contact } from "./containers/Contact/Contact";
import { MainVisual } from "./containers/MainVisual/MainVisual";
import { Service } from "./containers/Service/Service";
import { scroller } from "react-scroll";
import { useLocation, useNavigate } from "react-router-dom";

export const TopPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    // URLハッシュをチェックしてスクロール
    // CSR なので自前で制御する必要がある。
    const hash = location.hash.match(/^#(.*)/)?.[1];
    if (hash) {
      scroller.scrollTo(hash, {
        duration: 500,
        smooth: true,
      });
      navigate("/");
    }
  }, [location.hash, navigate]);

  return (
    <Grid container className="TopPage" sx={sx}>
      <TopPageHeader />
      <MainVisual />
      <About />
      <Service />
      <Company />
      <Contact />
      <Footer />
    </Grid>
  );
};

const sx: SxProps<Theme> = (theme) => ({
  "&.TopPage": {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    minWidth: {
      md: "768px",
      xs: "374px",
    },
  },
});
